import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, ShieldOff, Flower2 } from "lucide-react";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConsentPage() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const wantsUnsub = params.get("azione") === "disiscrivi";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/consent/${token}`).then(r => setInfo(r.data)).catch(() => setError("Questo link non è valido o è scaduto."));
  }, [token]);

  const act = async (action) => {
    setBusy(true);
    try { await axios.post(`${API}/public/consent/${token}/${action}`); setDone(action); }
    catch { setError("Operazione non riuscita, riprova più tardi."); } finally { setBusy(false); }
  };

  const shopLink = info?.shop_subdomain ? `/fioristi/${info.shop_subdomain}` : "/";
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16 bg-cream" data-testid="consent-page">
      <div className="bg-white rounded-2xl border border-cream-dark p-8 max-w-md w-full text-center shadow-sm">
        <Flower2 className="h-12 w-12 text-brand mx-auto mb-4" />
        {error && <p className="text-forest" data-testid="consent-error">{error}</p>}
        {!error && !info && <p className="text-sage">Un attimo…</p>}
        {info && done === "accetta" && (<>
          <ShieldCheck className="h-8 w-8 text-emerald-600 mx-auto mb-2" />
          <h1 className="font-serif text-2xl text-forest mb-2" data-testid="consent-accepted">Grazie{info.name ? `, ${info.name.split(" ")[0]}` : ""}!</h1>
          <p className="text-sage leading-relaxed">Riceverai le proposte di <strong>{info.shop_name}</strong> per le occasioni speciali. Potrai disiscriverti in ogni momento dal link presente in ogni email.</p>
          <Link to={shopLink} className="inline-block mt-6 text-brand underline underline-offset-2">Visita il negozio</Link>
        </>)}
        {info && done === "disiscrivi" && (<>
          <ShieldOff className="h-8 w-8 text-forest mx-auto mb-2" />
          <h1 className="font-serif text-2xl text-forest mb-2" data-testid="consent-unsubscribed">Disiscrizione completata</h1>
          <p className="text-sage leading-relaxed"><strong>{info.shop_name}</strong> non ti invierà più proposte commerciali. Se cambierai idea, basterà chiederlo in negozio.</p>
          <Link to="/" className="inline-block mt-6 text-brand underline underline-offset-2">Torna a FlowerLive</Link>
        </>)}
        {info && !done && (wantsUnsub ? (<>
          <h1 className="font-serif text-2xl text-forest mb-2">Non vuoi più ricevere le proposte di {info.shop_name}?</h1>
          <p className="text-sage leading-relaxed mb-6">{info.unsubscribed ? "Risulti già disiscritto: non riceverai altre comunicazioni." : "Ci dispiace vederti andare. Conferma per non ricevere più email o messaggi promozionali."}</p>
          {!info.unsubscribed && <Button onClick={() => act("disiscrivi")} disabled={busy} variant="outline" className="border-forest text-forest" data-testid="consent-unsubscribe-btn">Confermo, disiscrivimi</Button>}
        </>) : (<>
          <h1 className="font-serif text-2xl text-forest mb-2">Ciao{info.name ? ` ${info.name.split(" ")[0]}` : ""}, restiamo in contatto?</h1>
          <p className="text-sage leading-relaxed mb-6"><strong>{info.shop_name}</strong> vorrebbe inviarti, poche volte l'anno, le sue proposte per le occasioni speciali. Puoi revocare il consenso quando vuoi.</p>
          {info.consent_marketing && !info.unsubscribed ? <p className="text-emerald-700 text-sm mb-4" data-testid="consent-already">Hai già dato il consenso: grazie!</p> : (
            <Button onClick={() => act("accetta")} disabled={busy} className="bg-brand text-white hover:bg-brand-dark px-6" data-testid="consent-accept-btn">Sì, voglio ricevere le proposte</Button>
          )}
          <button onClick={() => act("disiscrivi")} disabled={busy} className="block mx-auto mt-4 text-xs text-sage hover:text-forest underline" data-testid="consent-decline-btn">No grazie, non contattatemi</button>
        </>))}
      </div>
    </div>
  );
}
